import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { MetaPixel } from './components/MetaPixel';
render(<>
    <MetaPixel data-id="element-250" />
    <App data-id="element-251" />
  </>, document.getElementById('root'));